export interface ShareOptions {
  title: string;
  text?: string;
  files?: File[];
}

/**
 * Check if the Web Share API with file sharing is supported
 */
export function canShareFiles(): boolean {
  if (typeof navigator === 'undefined' || !navigator.share || !navigator.canShare) {
    return false;
  }

  // Create a dummy file to test file sharing support
  const testFile = new File(['test'], 'test.pdf', { type: 'application/pdf' });
  return navigator.canShare({ files: [testFile] });
}

/**
 * Share content using Web Share API
 */
export async function shareContent(options: ShareOptions): Promise<boolean> {
  try {
    await navigator.share({
      title: options.title,
      text: options.text,
      files: options.files,
    });
    return true;
  } catch (error) {
    // User cancelled or share failed
    if ((error as Error).name === 'AbortError') {
      return false; // User cancelled, not an error
    }
    throw error;
  }
}

/**
 * Download a file as fallback for browsers without Web Share API
 */
export function downloadFile(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
